import { createSlice } from "@reduxjs/toolkit";
import { cancelSubscription, checkSubscriptionStatus, getPlans, subcriptionSession } from "../actions/subscription";

const states = {
  data: null,
  loading: false,
  error: false,
  subBtnLoading: false,
  cancelBtnLoading: false,
  subscriptionStatus: ""
};

export const subscriptions = createSlice({
  initialState: states,
  name: "subscription",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPlans.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(getPlans.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.data = action.payload.data?.data;
    });
    builder.addCase(getPlans.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });

    // SUBSCRIPTION CASE
    builder.addCase(subcriptionSession.pending, (state, action) => {
      state.subBtnLoading = true;
    });
    builder.addCase(subcriptionSession.fulfilled, (state, action) => {
      state.subBtnLoading = false;
    });
    builder.addCase(subcriptionSession.rejected, (state, action) => {
      state.subBtnLoading = false;
    });

    // SUBSCRIPTION STATUS
    builder.addCase(checkSubscriptionStatus.pending, (state, action) => {
      state.subBtnLoading = true;
    });
    builder.addCase(checkSubscriptionStatus.fulfilled, (state, action) => {
      state.subBtnLoading = false;
      state.subscriptionStatus = action?.payload?.data?.data
    });
    builder.addCase(checkSubscriptionStatus.rejected, (state, action) => {
      state.subBtnLoading = false;
    });

    // SUBSCRIPTION STATUS
    builder.addCase(cancelSubscription.pending, (state, action) => {
      state.cancelBtnLoading = true;
    });
    builder.addCase(cancelSubscription.fulfilled, (state, action) => {
      state.cancelBtnLoading = false;
    });
    builder.addCase(cancelSubscription.rejected, (state, action) => {
      state.cancelBtnLoading = false;
    });
  },
});

export default subscriptions.reducer;
